import React from 'react'
import { RootNavigator } from '@/routes'

function App() {
  return <RootNavigator />
}

export default App
